import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { timer } from "rxjs";
import { LocalstorageService, UserService } from "../../../../shared";
import { SchoolBusAlertModifyComponent } from "./school-bus-alert-modify/school-bus-alert-modify.component";
import { BusSelectorComponent } from "../bus-selector/bus-selector.component";
import { DataService_BusTrackerMap } from "../shared/data.service";
import { GMap } from "../shared/gmap";
import { SchoolService } from "../../../../shared/services/school.service";
import { BTBusGetPersonPhotosRequest } from "../shared/BTBusGetPersonPhotosRequest";
import { MarkerClusterer } from "../../clustering/MarkerClusterer";

@Component({
	selector: "caass-bus-main-map",
	templateUrl: "./bus-main-map.component.html",
	styleUrls: ["./bus-main-map.component.css"],
})
export class BusMainMapComponent implements OnInit {
	constructor(
		private userService: UserService,
		private schoolService: SchoolService,
		private mapService: DataService_BusTrackerMap,
		private dialogService: DialogService,
		private localService: LocalstorageService
	) {}

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.loadSounds();
	}

	ngOnDestory() {
		this.Refresher.unsubscribe();
	}

	@HostListener("window:keydown", ["$event"])
	LogKeys(e: KeyboardEvent) {
		if (e.keyCode === 27 || e.keyCode === 46) {
			this.StudentUnSpiderfy();
		}
	}

	////////////////////////////////////////////////////////////////////////////////
	//#region Data
	////////////////////////////////////////////////////////////////////////////////

	//#region Lists of Data
	lstSelectedBuses: any = [];
	lstSelectedStudents: any = [];
	lstBusPositions: any = [];
	lstStudentPositions: any = [];
	lstGeoFence: any = [];

	//For Clustering
	lstBusDataPoints: google.maps.Data.Feature[] = [];
	lstStudentOnDataPoints: google.maps.Data.Feature[] = [];
	lstStudentOffDataPoints: google.maps.Data.Feature[] = [];

	BusClustererInited: boolean = false;
	StudentOnClustererInited: boolean = false;
	StudentOffClustererInited: boolean = false;

	BusClusterer: MarkerClusterer = null;
	StudentOnClusterer: MarkerClusterer = null;
	StudentOffClusterer: MarkerClusterer = null;

	BusesFromSelector: any = [];
	StudentsFromSelector: any = [];
	//#endregion

	//#region General
	ShowMap: any = false;
	ShowSideBar: any = false;
	user: any;
	MapPrefs: any;
	ShowInfo: any = false;
	TrafficLayer: google.maps.TrafficLayer = new google.maps.TrafficLayer();
	InitStylesAndListeners: any = false;
	options: any;
	overlays: any[] = [];
	Init: boolean = false;

	@ViewChild(GMap)
	mapRef: GMap;

	@ViewChild(BusSelectorComponent)
	selectorRef: BusSelectorComponent;
	//#endregion

	//#region Refresh
	RefreshMapSeconds: any = 60;
	MinimumRefreshSeconds: any = 10;
	Refresher: any;
	RefreshTimer: any;
	//#endregion

	//#region Preferences

	ShowAllBuses: any = true;
	BusSchoolOptionID: any = 0;
	lstBusSchoolOption: any = [
		{
			ID: 0,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "My Schools Only",
		},
		{
			ID: 2,
			Desc: "Selected School Only",
		},
	];
	StudentSchoolOptionID: any = 0;
	lstStudentSchoolOption: any = [
		{
			ID: 0,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "My Schools Only",
		},
		{
			ID: 2,
			Desc: "Selected School Only",
		},
	];
	BusSchoolID: any = -1;
	BusSchool: any = null;
	BusSeverityOption: any = 0;
	lstSeverity: any = [
		{
			ID: 0,
			Desc: "All",
		},
		{
			ID: -1,
			Desc: "Has Alert",
		},
		{
			ID: -2,
			Desc: "No Alerts",
		},
		{
			ID: 3,
			Desc: "Low",
		},
		{
			ID: 2,
			Desc: "Medium",
		},
		{
			ID: 1,
			Desc: "High",
		},
		{
			ID: -3,
			Desc: "Speed Warning",
		},
	];

	StudentSchoolID: any = -1;
	StudentSchool: any = null;
	lstSchool: any = [];
	StudentSwipeOn: any = false;
	StudentSwipeOff: any = false;
	StudentShowLastTransactionOnly: any = false;
	ShowTraffic: any = false;
	HideUnselect: any = false;

	ShowBusNumber: any = true;
	ShowStudentCount: any = false;
	ShowSpeed: any = false;
	ShowAlert: any = true;
	ShowBusScanTime: any = false;

	ShowStudentName: any = true;
	ShowStudentID: any = false;
	ShowStudentCurrentBus: any = false;
	ShowStudentBus: any = false;
	ShowStudentScanTime: any = false;
	ShowScheduledRider: any = false;

	BusTextColor: any = "#000000";
	DefaultBusTextColor: any = "#000000";
	StudentTextColor: any = "#0000FF";
	DefaultStudentTextColor: any = "#0000FF";

	ShowGeoFences: any = true;
	HideInactiveGeoFences: any = true;

	SpeedAlertMph: any = 70;
	SpeedingSeverity: any = 3;
	//#endregion

	//#region Student Spiderfy
	Tolerance: any = 35;
	SpiderMaxLegs: any = 10; //10;
	SpiderLegLength: any = 0.01;
	ZoomCoefficient: any = 0.0000001; //0.1;
	TILE_SIZE = 256;
	SpiderfyBusStudentRideTxnID: any = -1;
	lstOverlaps: any = [];
	//#endregion

	//#region Loading

	PrefLoading: boolean = true;
	TopBarLoading: boolean = false;
	GeoFenceLoading: boolean = false;
	BusLoading: boolean = false;
	StudentLoading: boolean = false;
	UpdatingGeoFences: boolean = false;
	UpdatingBuses: boolean = false;
	UpdatingStudents: boolean = false;
	UpdatingTraffic: boolean = false;
	UpdatingLabels: boolean = false;
	UpdatingBusLabels: boolean = false;
	UpdatingStudentLabels: boolean = false;
	UpdatingDeselect: boolean = false;

	//#endregion

	//#region Sounds
	PlaySounds: any = false; //Must turn on manually (Sounds can't play w/o user interaction)
	audio: any = new Audio();

	AccidentHighSound: any = null;
	HighSeveritySound: any = null;
	MediumSeveritySound: any = null;
	LowSeveritySound: any = null;
	//#endregion

	//#endregion
	////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////
	//#region Load Data
	////////////////////////////////////////////////////////////////////////////////

	loadSounds() {
		var result = this.mapService.BusTrackerMapSoundsSelect();
		result.subscribe(
			(response) => {
				var data: any = response;

				if (data.length > 0) {
					data = data[0];
				}

				this.AccidentHighSound = window.URL.createObjectURL(this.dataURIToMP3Blob(data.AccidentHighSound));
				this.HighSeveritySound = window.URL.createObjectURL(this.dataURIToMP3Blob(data.HighSeveritySound));
				this.MediumSeveritySound = window.URL.createObjectURL(this.dataURIToMP3Blob(data.MediumSeveritySound));
				this.LowSeveritySound = window.URL.createObjectURL(this.dataURIToMP3Blob(data.LowSeveritySound));

				this.loadSchools();
			},
			(error) => {}
		);
	}

	loadSchools() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				if (this.lstSchool.length > 0) {
					this.BusSchoolID = this.lstSchool[0].SchoolID;
					this.BusSchool = this.lstSchool[0];

					this.StudentSchoolID = this.lstSchool[0].SchoolID;
					this.StudentSchool = this.lstSchool[0];
				}

				this.loadPreferences();
			},
			(error) => {}
		);
	}

	loadPreferences() {
		this.PrefLoading = true;

		var result = this.mapService.BusMapPreferenceSelect(this.user.personID);
		result.subscribe(
			(response) => {
				this.MapPrefs = response[0];

				this.RefreshMapSeconds = Number(this.MapPrefs.RefreshSeconds);
				this.MinimumRefreshSeconds = Number(this.MapPrefs.MinimumRefreshSeconds);
				this.SpeedAlertMph = Number(this.MapPrefs.SpeedAlertMph);
				this.RefreshTimer = timer(this.RefreshMapSeconds * 1000, this.RefreshMapSeconds * 1000);
				this.Refresher = this.RefreshTimer.subscribe((val) => {
					this.onRefresh();
				});

				this.options = {
					center: {
						lat: Number(this.MapPrefs.DefaultLat),
						lng: Number(this.MapPrefs.DefaultLong),
					},
					zoom: Number(this.MapPrefs.DefaultZoom),
				};

				this.ShowMap = true;

				this.PrefLoading = false;

				this.loadTopBarOptions();
			},
			(error) => {
				this.PrefLoading = false;
			}
		);
	}

	loadTopBarOptions() {
		this.TopBarLoading = true;

		var BT_MapOptions = this.localService.getItem("BT_MapOptions");

		if (BT_MapOptions != undefined) {
			this.ShowAllBuses = BT_MapOptions.ShowAllBuses == undefined ? true : BT_MapOptions.ShowAllBuses;
			this.BusSchoolOptionID = BT_MapOptions.BusSchoolOptionID == undefined ? 0 : BT_MapOptions.BusSchoolOptionID;
			this.StudentSchoolOptionID = BT_MapOptions.StudentSchoolOptionID == undefined ? 0 : BT_MapOptions.StudentSchoolOptionID;
			this.BusSchoolID = BT_MapOptions.BusSchoolID == undefined ? 0 : BT_MapOptions.BusSchoolID;
			this.StudentSchoolID = BT_MapOptions.StudentSchoolID == undefined ? 0 : BT_MapOptions.StudentSchoolID;

			var BusSchoolFound: boolean = false;
			for (var z = 0; z < this.lstSchool.length; z++) {
				var next = this.lstSchool[z];

				if (next.SchoolID == this.BusSchoolID) {
					this.BusSchool = next;
					BusSchoolFound = true;
					break;
				}
			}

			if (!BusSchoolFound) {
				this.BusSchool = this.lstSchool[0];
				this.BusSchoolID = this.lstSchool[0].SchoolID;
			}

			var StudentSchoolFound: boolean = false;
			for (var z = 0; z < this.lstSchool.length; z++) {
				var next = this.lstSchool[z];

				if (next.SchoolID == this.StudentSchoolID) {
					this.StudentSchool = next;
					break;
				}
			}

			if (!StudentSchoolFound) {
				this.StudentSchool = this.lstSchool[0];
				this.StudentSchoolID = this.lstSchool[0].SchoolID;
			}

			this.StudentSwipeOn = BT_MapOptions.StudentSwipeOn == undefined ? false : BT_MapOptions.StudentSwipeOn;
			this.StudentSwipeOff = BT_MapOptions.StudentSwipeOff == undefined ? false : BT_MapOptions.StudentSwipeOff;
			this.StudentShowLastTransactionOnly =
				BT_MapOptions.StudentShowLastTransactionOnly == undefined ? false : BT_MapOptions.StudentShowLastTransactionOnly;
			this.ShowTraffic = BT_MapOptions.ShowTraffic == undefined ? false : BT_MapOptions.ShowTraffic;
			this.ShowBusNumber = BT_MapOptions.ShowBusNumber == undefined ? true : BT_MapOptions.ShowBusNumber;
			this.ShowStudentCount = BT_MapOptions.ShowStudentCount == undefined ? false : BT_MapOptions.ShowStudentCount;
			this.ShowSpeed = BT_MapOptions.ShowSpeed == undefined ? false : BT_MapOptions.ShowSpeed;
			this.ShowAlert = BT_MapOptions.ShowAlert == undefined ? true : BT_MapOptions.ShowAlert;
			this.ShowBusScanTime = BT_MapOptions.ShowBusScanTime == undefined ? false : BT_MapOptions.ShowBusScanTime;
			this.ShowStudentName = BT_MapOptions.ShowStudentName == undefined ? true : BT_MapOptions.ShowStudentName;
			this.ShowStudentID = BT_MapOptions.ShowStudentID == undefined ? false : BT_MapOptions.ShowStudentID;
			this.ShowStudentCurrentBus = BT_MapOptions.ShowStudentCurrentBus == undefined ? false : BT_MapOptions.ShowStudentCurrentBus;
			this.ShowStudentBus = BT_MapOptions.ShowStudentBus == undefined ? false : BT_MapOptions.ShowStudentBus;
			this.ShowStudentScanTime = BT_MapOptions.ShowStudentScanTime == undefined ? false : BT_MapOptions.ShowStudentScanTime;
			this.ShowScheduledRider = BT_MapOptions.ShowScheduledRider == undefined ? false : BT_MapOptions.ShowScheduledRider;
			this.HideUnselect = BT_MapOptions.HideUnselect == undefined ? false : BT_MapOptions.HideUnselect; //Always default to false?
			this.BusTextColor = BT_MapOptions.BusTextColor == undefined ? this.DefaultBusTextColor : BT_MapOptions.BusTextColor;
			this.StudentTextColor = BT_MapOptions.StudentTextColor == undefined ? this.DefaultStudentTextColor : BT_MapOptions.StudentTextColor;
			this.SpeedAlertMph = BT_MapOptions.SpeedAlertMph == undefined ? 70 : BT_MapOptions.SpeedAlertMph;
			this.ShowGeoFences = BT_MapOptions.ShowGeoFences == undefined ? true : BT_MapOptions.ShowGeoFences;
			this.HideInactiveGeoFences = BT_MapOptions.HideInactiveGeoFences == undefined ? true : BT_MapOptions.HideInactiveGeoFences;
			this.BusSeverityOption = BT_MapOptions.BusSeverityOption == undefined ? 0 : BT_MapOptions.BusSeverityOption;
		}

		this.TopBarLoading = false;

		this.loadGeoFences(); //Only load once per page load (don't need to refresh every minute)
	}

	loadGeoFences() {
		this.GeoFenceLoading = true;

		var result = this.mapService.GeoFenceSelectList();
		result.subscribe(
			(response) => {
				this.lstGeoFence = response;

				this.GeoFenceLoading = false;

				this.loadBusPositions();
			},
			(error) => {
				this.GeoFenceLoading = false;
			}
		);
	}

	loadBusPositions() {
		this.BusLoading = true;

		var result = this.mapService.BusPositionSelectList(this.user.userID);
		result.subscribe(
			(response) => {
				this.lstBusPositions = response;

				this.BusLoading = false;

				this.loadStudentPositions();
				// this.UpdateOverlays();
			},
			(error) => {
				this.BusLoading = false;
			}
		);
	}

	loadStudentPositions() {
		this.StudentLoading = true;

		var result = this.mapService.StudentPositionSelectList(this.user.userID);
		result.subscribe(
			(response) => {
				this.lstStudentPositions = response;

				this.StudentLoading = false;

				if (this.Init == false) {
					this.Init = true;
					this.UpdateMapStylesAndListeners();
				} else {
					this.UpdateOverlays();
				}
			},
			(error) => {}
		);
	}

	//#endregion
	////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////
	//#region Buttons
	////////////////////////////////////////////////////////////////////////////////

	//#region Main
	onRefresh() {
		this.RefreshTimer = timer(this.RefreshMapSeconds * 1000, this.RefreshMapSeconds * 1000);
		this.Refresher.unsubscribe();
		this.Refresher = this.RefreshTimer.subscribe((val) => {
			this.onRefresh();
		});

		this.loadBusPositions();
	}

	onSendAlert() {
		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var lstBusesFromMain: any = [];

		//
		// Buses that were clicked on
		//
		for (var z = 0; z < this.lstSelectedBuses.length; z++) {
			var next = this.lstSelectedBuses[z];

			lstBusesFromMain = [...lstBusesFromMain, { BusID: next.BusID }];
		}

		//
		// Buses selected by selector
		//
		for (var z = 0; z < this.BusesFromSelector.length; z++) {
			var next = this.BusesFromSelector[z];

			lstBusesFromMain = [...lstBusesFromMain, { BusID: next }];
		}

		var ref = this.dialogService.open(SchoolBusAlertModifyComponent, {
			header: "Send Alert",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				user: this.user,
				lstSelectedBuses: lstBusesFromMain,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
			}
		});
	}

	onSearch() {
		this.ShowSideBar = !this.ShowSideBar;
	}

	onDeselect() {
		this.UpdatingDeselect = true;

		this.lstSelectedBuses = [];
		this.lstSelectedStudents = [];

		this.BusesFromSelector = [];
		this.StudentsFromSelector = [];

		if (this.selectorRef != undefined) {
			this.selectorRef.SelectedBuses = [];
		}

		this.mapRef.map.data.forEach((element) => {
			element.setProperty("Selected", false);
		});

		this.UpdatingDeselect = false;

		this.UpdateOverlays();
	}

	onToggleInfo() {
		this.ShowInfo = !this.ShowInfo;

		// console.log("PrefLoading= " + this.PrefLoading);
		// console.log("TopBarLoading= " + this.TopBarLoading);
		// console.log("GeoFenceLoading= " + this.GeoFenceLoading);
		// console.log("BusLoading= " + this.BusLoading);
		// console.log("StudentLoading= " + this.StudentLoading);
		// console.log("UpdatingGeoFences= " + this.UpdatingGeoFences);
		// console.log("UpdatingBuses= " + this.UpdatingBuses);
		// console.log("UpdatingStudents= " + this.UpdatingStudents);
		// console.log("UpdatingTraffic= " + this.UpdatingTraffic);
		// console.log("UpdatingLabels= " + this.UpdatingLabels);
		// console.log("UpdatingBusLabels= " + this.UpdatingBusLabels);
		// console.log("UpdatingStudentLabels= " + this.UpdatingStudentLabels);
	}

	onPlaySoundsClick() {
		this.PlaySounds = !this.PlaySounds;
	}

	//#endregion

	//#region Text Color Reset
	onResetBusLabelColor() {
		this.onBusTextColorChange(this.DefaultBusTextColor);
	}

	onResetStudentLabelColor() {
		this.onStudentTextColorChange(this.DefaultStudentTextColor);
	}
	//#endregion

	//#endregion
	////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////
	//#region Events
	////////////////////////////////////////////////////////////////////////////////

	//#region Top Bar Preferences

	onShowAllBusChange(val) {
		this.ShowAllBuses = val;

		this.UpdateBuses();
		this.UpdatePreferences();
	}

	onBusSchoolOptionIDChange(val) {
		this.BusSchoolOptionID = val;

		this.UpdateBuses();
		this.UpdatePreferences();
	}

	onBusSchoolIDChange(val) {
		this.BusSchoolID = val;

		for (var z = 0; z < this.lstSchool.length; z++) {
			var next = this.lstSchool[z];

			if (next.SchoolID == this.BusSchoolID) {
				this.BusSchool = next;
				break;
			}
		}

		this.UpdateBuses();
		this.UpdatePreferences();
	}

	onBusSchoolChange(val) {
		this.BusSchool = val;
		this.BusSchoolID = this.BusSchool.SchoolID;

		this.UpdateBuses();
		this.UpdatePreferences();
	}

	onBusSeverityOptionChange(val) {
		this.BusSeverityOption = val;

		this.UpdateBuses();
		this.UpdatePreferences();
	}

	onStudentSchoolOptionIDChange(val) {
		this.StudentSchoolOptionID = val;

		this.UpdateStudents();
		this.UpdatePreferences();
	}

	onStudentSchoolIDChange(val) {
		this.StudentSchoolID = val;

		for (var z = 0; z < this.lstSchool.length; z++) {
			var next = this.lstSchool[z];

			if (next.SchoolID == this.StudentSchoolID) {
				this.StudentSchool = next;
				break;
			}
		}

		this.UpdateStudents();
		this.UpdatePreferences();
	}

	onStudentSchoolChange(val) {
		this.StudentSchool = val;
		this.StudentSchoolID = this.StudentSchool.SchoolID;

		this.UpdateStudents();
		this.UpdatePreferences();
	}

	onStudentSwipeOnChange(val) {
		this.StudentSwipeOn = val;

		this.UpdateStudents();
		this.UpdatePreferences();
	}

	onStudentSwipeOffChange(val) {
		this.StudentSwipeOff = val;

		this.UpdateStudents();
		this.UpdatePreferences();
	}

	onStudentShowLastTransactionOnlyChange(val) {
		this.StudentShowLastTransactionOnly = val;

		this.UpdateStudents();
		this.UpdatePreferences();
	}

	onShowGeoFencesChange(val) {
		this.ShowGeoFences = val;

		this.UpdateGeoFences();
		this.UpdatePreferences();
	}

	onHideInactiveGeoFencesChange(val) {
		this.HideInactiveGeoFences = val;

		this.UpdateGeoFences();
		this.UpdatePreferences();
	}

	onHideUnselectChange(val) {
		this.HideUnselect = val;

		this.UpdateBuses();
		this.UpdateStudents();
		this.UpdatePreferences();
	}

	onShowTrafficChange(val) {
		this.ShowTraffic = val;

		this.UpdateTraffic();
		this.UpdatePreferences();
	}

	onShowBusNumberChange(val) {
		this.ShowBusNumber = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowAlertChange(val) {
		this.ShowAlert = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentCountChange(val) {
		this.ShowStudentCount = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowSpeedChange(val) {
		this.ShowSpeed = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowBusScanTimeChange(val) {
		this.ShowBusScanTime = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onSpeedAlertMphChange(val) {
		this.SpeedAlertMph = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusTextColorChange(val) {
		this.BusTextColor = val;

		this.UpdateBusLabelColors();
		this.UpdatePreferences();
	}

	onShowStudentNameChange(val) {
		this.ShowStudentName = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentIDChange(val) {
		this.ShowStudentID = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentBusChange(val) {
		this.ShowStudentBus = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentCurrentBusChange(val) {
		this.ShowStudentCurrentBus = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentScanTimeChange(val) {
		this.ShowStudentScanTime = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowScheduledRiderChange(val) {
		this.ShowScheduledRider = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onStudentTextColorChange(val) {
		this.StudentTextColor = val;

		this.UpdateStudentLabelColors();
		this.UpdatePreferences();
	}

	//#endregion

	//#region Selector
	onSelectBusesOnMap(val) {
		this.BusesFromSelector = val.Buses;
		this.StudentsFromSelector = val.Students;

		this.UpdateOverlays();
	}
	//#endregion

	//#endregion
	////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////
	//#region Helpers
	////////////////////////////////////////////////////////////////////////////////

	//#region Main

	// Runs 1 time on init
	UpdateAll() {
		this.UpdateGeoFences();
		this.UpdateBuses();
		this.UpdateStudents();
		this.UpdateTraffic();
	}

	//
	// Note: Force Redraw = true when a bus's position changes
	//       (Somehow Super View Port Alg. has references to list of points and won't detect
	//       changes in Calculate method because the locations changed automatically. See
	//       PointsEqual method)
	//
	UpdateBusClusterer(ForceRedraw: boolean = false){
		if(this.BusClustererInited == false){
			this.BusClustererInited = true;

			this.BusClusterer = new MarkerClusterer({ lstPoints: this.lstBusDataPoints, map: this.mapRef.getMap() });
		}
		else{
			this.BusClusterer.mergeMarkers("Bus", this.lstBusDataPoints, false, ForceRedraw);
		}
	}

	//
	// NOTE: Force Redraw isn't used for students
	//       Program assumes their positions never change (speeds up performance)
	//       If student positions change you will have to reload the page to see the changes
	//       (Only buses should be moving unless someone manually edits SQL data)
	//
	UpdateStudentOnClusterer(){
		if(this.StudentOnClustererInited == false){
			this.StudentOnClustererInited = true;

			this.StudentOnClusterer  = new MarkerClusterer({ lstPoints: this.lstStudentOnDataPoints, map: this.mapRef.getMap() });
		}
		else{
			this.StudentOnClusterer.mergeMarkers("Student", this.lstStudentOnDataPoints, false, false);
		}
	}

	UpdateStudentOffClusterer(){
		if(this.StudentOffClustererInited == false){
			this.StudentOffClustererInited = true;

			this.StudentOffClusterer  = new MarkerClusterer({ lstPoints: this.lstStudentOffDataPoints, map: this.mapRef.getMap() });
		}
		else{
			this.StudentOffClusterer.mergeMarkers("Student", this.lstStudentOffDataPoints, false, false);
		}
	}

	UpdateGeoFences() {
		this.UpdatingGeoFences = true;

		//
		// Add or Delete Geofences
		//
		if (this.ShowGeoFences == true) {
			// Delete inactive if they are supposed to be hidden
			if (this.HideInactiveGeoFences == true) {
				this.DeleteInactiveGeoFences();
			}

			for (var z = 0; z < this.lstGeoFence.length; z++) {
				var next = this.lstGeoFence[z];

				this.CreateGeoFence(next);
			}
		} else {
			this.DeleteAllGeoFences();
		}

		this.UpdatingGeoFences = false;
	}

	UpdateBuses() {
		this.UpdatingBuses = true;

		var ForceRedraw: boolean = false;

		//
		// Delete all if show buses is turned off
		//
		if (this.ShowAllBuses == false) {
			this.DeleteAllBuses();
		}
		//
		// Else draw or update buses
		//
		else {
			if (this.HideUnselect == true) {
				this.DeleteUnselectedBuses();
			}

			//My Schools Only
			if (this.BusSchoolOptionID == 1) {
				this.DeleteBusesFromOtherSchools();
			}
			//Selected School Only
			else if (this.BusSchoolOptionID == 2) {
				this.DeleteBusesFromUnselectedSchools();
			}

			//Severity Option
			if (this.BusSeverityOption != 0) {
				if (this.BusSeverityOption == -1) {
					this.DeleteBusesWithoutAlerts();
				} else if (this.BusSeverityOption == -2) {
					this.DeleteBusesWithAlerts();
				} else if (this.BusSeverityOption == 3) {
					this.DeleteBusesWithoutLowAlerts();
				} else if (this.BusSeverityOption == 2) {
					this.DeleteBusesWithoutMediumAlerts();
				} else if (this.BusSeverityOption == 1) {
					this.DeleteBusesWithoutHighAlerts();
				} else if (this.BusSeverityOption == -3) {
					this.DeleteBusesWithoutSpeedAlerts();
				}
			}

			for (var z = 0; z < this.lstBusPositions.length; z++) {
				var next = this.lstBusPositions[z];

				ForceRedraw = this.CreateBusMarker(next) || ForceRedraw;
			}
		}

		this.UpdatingBuses = false;

		this.UpdateBusClusterer(ForceRedraw);
	}

	UpdateStudents() {
		this.UpdatingStudents = true;

		//
		// Delete Large amounts of students?
		//
		if (this.StudentSwipeOn == false && this.StudentSwipeOff == false) {
			this.DeleteAllStudents();
			this.UpdatingStudents = false;
			return;
		} else {
			//
			// Delete Half of the students?
			//
			if (this.StudentSwipeOn == false) {
				this.DeleteStudentSwipeOn();
			} else if (this.StudentSwipeOff == false) {
				this.DeleteStudentSwipeOff();
			}

			//
			// Delete unselected
			//
			if (this.StudentShowLastTransactionOnly == true) {
				this.DeleteStudentPastTransactions();
			}
			if (this.HideUnselect == true) {
				this.DeleteUnselectedStudents();
			}

			//
			// Check School Option
			//

			// My Schools Only
			if (this.StudentSchoolOptionID == 1) {
				this.DeleteStudentsFromOtherSchools();
			}
			// Selected School Only
			else if (this.StudentSchoolOptionID == 2) {
				this.DeleteStudentsFromUnselectedSchools();
			}

			//
			// Draw the rest
			//
			for (var z = 0; z < this.lstStudentPositions.length; z++) {
				var next = this.lstStudentPositions[z];

				this.CreateStudentMarker(next);
			}
		}

		this.UpdatingStudents = false;

		this.UpdateStudentOnClusterer();
		this.UpdateStudentOffClusterer();
	}

	UpdateTraffic() {
		this.UpdatingTraffic = true;

		if (this.ShowTraffic == true) {
			this.TrafficLayer.setMap(this.mapRef.map);
		} else {
			this.TrafficLayer.setMap(null);
		}

		this.UpdatingTraffic = false;
	}

	// Runs each time the data refreshes
	UpdateOverlays() {
		this.StudentUnSpiderfy();

		this.UpdateBuses();
		this.UpdateStudents();
	}

	UpdateLabels() {
		this.UpdatingLabels = true;

		//
		// Buses
		//

		for(var z = 0; z < this.lstBusDataPoints.length; z++){
			var element = this.lstBusDataPoints[z];

			let NextLabel: any = "";

			var ShowSpeedWarning = false;

			if (this.ShowBusNumber == true) {
				NextLabel += element.getProperty("BusNbr") + " ";
			}
			if (this.ShowStudentCount == true && element.getProperty("StudentCount") > 0) {
				NextLabel += "(" + element.getProperty("StudentCount") + " students) ";
			}
			if (this.ShowSpeed == true) {
				NextLabel += "(" + element.getProperty("SpeedMph") + " mph) ";
			}
			if (this.ShowAlert == true && element.getProperty("HasAlert") == true) {
				NextLabel += "(" + element.getProperty("AlertDesc") + ") ";
			}
			if (this.ShowBusScanTime == true) {
				NextLabel += "(" + element.getProperty("c_dateDesc") + ") ";
			}

			if (Number(element.getProperty("SpeedMph")) >= Number(this.SpeedAlertMph) && Number(this.SpeedAlertMph) > 0) {
				NextLabel += "(SPEED)";
				ShowSpeedWarning = true;
			}

			element.setProperty("BusLabel", NextLabel);
			element.setProperty("ShowSpeedWarning", ShowSpeedWarning);
		}

		//
		// Student On
		//
		for(var z = 0; z < this.lstStudentOnDataPoints.length; z++){
			var element = this.lstStudentOnDataPoints[z];

			let NextLabel: any = "";

			if (this.ShowStudentName == true) {
				NextLabel += element.getProperty("StudentName") + " ";
			}
			if (this.ShowStudentID == true) {
				NextLabel += "(" + element.getProperty("StudentID") + ") ";
			}
			if (this.ShowStudentBus == true) {
				NextLabel += "(" + element.getProperty("BusNbr") + ") ";
			}
			if (this.ShowStudentCurrentBus == true) {
				NextLabel += "(" + element.getProperty("CurrentBusNbr") + ") ";
			}
			if (this.ShowStudentScanTime == true) {
				NextLabel += "(" + element.getProperty("c_dateDesc") + ") ";
			}
			if (this.ShowScheduledRider == true) {
				NextLabel += "(" + element.getProperty("isScheduledRiderDesc") + ") ";
			}

			element.setProperty("StudentLabel", NextLabel);
		}

		//
		// Student Off
		//
		for(var z = 0; z < this.lstStudentOffDataPoints.length; z++){
			var element = this.lstStudentOffDataPoints[z];

			let NextLabel: any = "";

			if (this.ShowStudentName == true) {
				NextLabel += element.getProperty("StudentName") + " ";
			}
			if (this.ShowStudentID == true) {
				NextLabel += "(" + element.getProperty("StudentID") + ") ";
			}
			if (this.ShowStudentBus == true) {
				NextLabel += "(" + element.getProperty("BusNbr") + ") ";
			}
			if (this.ShowStudentCurrentBus == true) {
				NextLabel += "(" + element.getProperty("CurrentBusNbr") + ") ";
			}
			if (this.ShowStudentScanTime == true) {
				NextLabel += "(" + element.getProperty("c_dateDesc") + ") ";
			}
			if (this.ShowScheduledRider == true) {
				NextLabel += "(" + element.getProperty("isScheduledRiderDesc") + ") ";
			}

			element.setProperty("StudentLabel", NextLabel);
		}

		this.UpdatingLabels = false;
	}

	UpdateBusLabelColors() {
		this.UpdatingBusLabels = true;

		for(var z = 0; z < this.lstBusDataPoints.length; z++){
			var element = this.lstBusDataPoints[z];

			element.setProperty("BusTextColor", this.BusTextColor);
		}

		this.mapRef.map.data.forEach((element) => {
			if(element.getProperty("GroupPoint") == true){
				if (element.getProperty("Type") == "Bus") {
					element.setProperty("BusTextColor", this.BusTextColor);
				}
			}
		});

		this.UpdatingBusLabels = false;
	}

	UpdateStudentLabelColors() {
		this.UpdatingStudentLabels = true;


		for(var z = 0; z < this.lstStudentOnDataPoints.length; z++){
			var element = this.lstStudentOnDataPoints[z];

			element.setProperty("StudentTextColor", this.StudentTextColor);
		}

		for(var z = 0; z < this.lstStudentOffDataPoints.length; z++){
			var element = this.lstStudentOffDataPoints[z];

			element.setProperty("StudentTextColor", this.StudentTextColor);
		}

		this.mapRef.map.data.forEach((element) => {
			if(element.getProperty("GroupPoint") == true){
				if (element.getProperty("Type") == "Student") {
					element.setProperty("StudentTextColor", this.StudentTextColor);
				}
			}
		});

		this.UpdatingStudentLabels = false;
	}

	//#endregion

	//#region Geo Fences

	CreateGeoFence(GeoFenceInfo) {
		//
		// Check if it should be drawn
		// (Hide inactive = true and Geofence is inactive)
		// (Already exists so skip it)
		//

		if (this.HideInactiveGeoFences == true && GeoFenceInfo.Active == false) {
			return;
		}

		var Exists = false;
		this.mapRef.map.data.forEach((element) => {
			if (element.getProperty("Type") == "GeoFence") {
				if (element.getProperty("GeoFenceID") == GeoFenceInfo.GeoFenceID) {
					Exists = true;
				}
			}
		});

		if (Exists) {
			return;
		} else {
			//
			// Doesn't already exists, create it
			// (If geofences inactive is toggled you might have active geofences
			// that already drawn, but you just want to add the inactive ones that were hidden)
			//

			let FenceLabel: any = "";

			FenceLabel = GeoFenceInfo.GeoFenceDesc;

			var lstLatLong: google.maps.LatLng[] = [];

			for (var z = 0; z < GeoFenceInfo.lstPoints.length; z++) {
				var next = GeoFenceInfo.lstPoints[z];

				lstLatLong = [...lstLatLong, new google.maps.LatLng({ lat: next.Lat, lng: next.Long })];
			}

			let FencePolygon: google.maps.Data.Polygon = new google.maps.Data.Polygon([lstLatLong]);

			let FenceFeatureOptions: google.maps.Data.FeatureOptions = {
				geometry: FencePolygon,
				properties: {
					Type: "GeoFence",
					GroupPoint: false,
					Label: FenceLabel,
					GeoFenceID: GeoFenceInfo.GeoFenceID,
					GeoFenceDesc: GeoFenceInfo.GeoFenceDesc,
					BusDesc: GeoFenceInfo.BusDesc,
					FillColor: GeoFenceInfo.FillColor,
					AlphaChannel: GeoFenceInfo.AlphaChannel,
					BusID: GeoFenceInfo.BusID,
					GeofenceTriggerTypeID: GeoFenceInfo.GeofenceTriggerTypeID,
					GeofenceTriggerTypeCD: GeoFenceInfo.GeofenceTriggerTypeCD,
					GeofenceTriggerTypeDesc: GeoFenceInfo.GeofenceTriggerTypeDesc,
					Severity: GeoFenceInfo.Severity,
					SeverityDesc: GeoFenceInfo.SeverityDesc,
					AlertComments: GeoFenceInfo.AlertComments,
					Active: GeoFenceInfo.Active,
					ActiveDesc: GeoFenceInfo.ActiveDesc,
					Lat: GeoFenceInfo.MidPointLat,
					Long: GeoFenceInfo.MidPointLong,
					lstPoints: GeoFenceInfo.lstPoints,
					Selected: false,
				},
			};

			let FenceFeature: google.maps.Data.Feature = new google.maps.Data.Feature(FenceFeatureOptions);
			this.mapRef.map.data.add(FenceFeature);
		}
	}

	DeleteInactiveGeoFences() {
		this.mapRef.map.data.forEach((element) => {
			if (element.getProperty("Type") == "GeoFence") {
				if (element.getProperty("Active") == false) {
					this.mapRef.map.data.remove(element);
				}
			}
		});
	}

	DeleteAllGeoFences() {
		this.mapRef.map.data.forEach((element) => {
			if (element.getProperty("Type") == "GeoFence") {
				this.mapRef.map.data.remove(element);
			}
		});
	}

	//#endregion

	//#region Bus Markers

	CreateBusMarker(BusInfo): boolean {

		//
		// Preserve selected list when reloading positions (refreshes every couple of seconds)
		//
		var AlreadySelected = false;
		for (var z = 0; z < this.lstSelectedBuses.length; z++) {
			var next = this.lstSelectedBuses[z];

			if (next.BusID == BusInfo.BusID) {
				AlreadySelected = true;
				break;
			}
		}

		var FromSelector = false;
		if (AlreadySelected == false) {
			for (var z = 0; z < this.BusesFromSelector.length; z++) {
				var next = this.BusesFromSelector[z];

				if (BusInfo.BusID == next) {
					FromSelector = true;
					break;
				}
			}
		}

		//Stop if unselected
		if (this.HideUnselect == true && !(AlreadySelected || FromSelector)) {
			return false;
		}

		//
		// Bus School Option
		//

		// My Schools Only
		if (this.BusSchoolOptionID == 1 && BusInfo.IsMySchool == false) {
			return false;
		} else if (this.BusSchoolOptionID == 2) {
			var ContainsSelected = false;

			for (var z = 0; z < BusInfo.lstSchoolIDs.length; z++) {
				var next = BusInfo.lstSchoolIDs[z];

				if (next == this.BusSchoolID) {
					ContainsSelected = true;
					break;
				}
			}

			if (ContainsSelected == false) {
				return false;
			}
		}

		let NextLabel: any = "";

		BusInfo.ShowSpeedWarning = false;

		if (this.ShowBusNumber == true) {
			NextLabel += BusInfo.BusNbr + " ";
		}
		if (this.ShowStudentCount == true && BusInfo.StudentCount > 0) {
			NextLabel += "(" + BusInfo.StudentCount + " students) ";
		}
		if (this.ShowSpeed == true) {
			NextLabel += "(" + BusInfo.SpeedMph + " mph) ";
		}
		if (this.ShowAlert == true && BusInfo.HasAlert == true) {
			NextLabel += "(" + BusInfo.AlertDesc + ") ";
		}
		if (this.ShowBusScanTime == true) {
			NextLabel += "(" + BusInfo.c_dateDesc + ") ";
		}
		if (Number(BusInfo.SpeedMph) >= Number(this.SpeedAlertMph) && Number(this.SpeedAlertMph) > 0) {
			NextLabel += "(SPEED)";
			BusInfo.ShowSpeedWarning = true;
		}

		//
		// Check if it exists
		//
		var Exists = false;
		for(var z = this.lstBusDataPoints.length-1; z >= 0; z--){
			var element = this.lstBusDataPoints[z];

			if (element.getProperty("BusID") == BusInfo.BusID) {
				//
				// If exists, update the bus's position and data
				//

				let newLocation: google.maps.LatLng = new google.maps.LatLng(Number(BusInfo.Lat), Number(BusInfo.Long));
				let newGeom: google.maps.Data.Point = new google.maps.Data.Point(newLocation);

				element.setGeometry(newGeom);

				element.setProperty("BusTextColor", this.BusTextColor);
				element.setProperty("BusLabel", NextLabel);
				element.setProperty("BusNbr", BusInfo.BusNbr);
				element.setProperty("BusDesc", BusInfo.BusDesc);
				element.setProperty("Driver_PersonName", BusInfo.Driver_PersonName);
				element.setProperty("BusRouteDesc", BusInfo.BusRouteDesc);
				element.setProperty("BusRouteTypeDesc", BusInfo.BusRouteTypeDesc);
				
				var PositionChanged: boolean = false;
				if(element.getProperty("Lat") != BusInfo.Lat || element.getProperty("Long") != BusInfo.Long){
					PositionChanged = true;
				}

				element.setProperty("Lat", BusInfo.Lat);
				element.setProperty("Long", BusInfo.Long);
				element.setProperty("HorizontalAccuracy", BusInfo.HorizontalAccuracy);

				element.setProperty("SpeedMph", BusInfo.SpeedMph);
				element.setProperty("ShowSpeedWarning", BusInfo.ShowSpeedWarning);
				element.setProperty("c_date", BusInfo.c_date);
				element.setProperty("c_dateDesc", BusInfo.c_dateDesc);
				element.setProperty("StudentCount", BusInfo.StudentCount);
				element.setProperty("ToPickupCount", BusInfo.ToPickupCount);
				element.setProperty("lstStudentsOnBus", BusInfo.lstStudentsOnBus);
				element.setProperty("lstStudentsToPickUp", BusInfo.lstStudentsToPickUp);
				element.setProperty("Selected", AlreadySelected || FromSelector);

				//
				//Play Sound?
				//
				// New Alert
				if (element.getProperty("HasAlert") == false && BusInfo.HasAlert == true) {
					this.PlayAlertSound(BusInfo.Severity, BusInfo.IsAccident);
				}
				// Higher Severity Alert
				else if (element.getProperty("HasAlert") == true && BusInfo.HasAlert == true && element.getProperty("Severity") > BusInfo.Severity) {
					this.PlayAlertSound(BusInfo.Severity, BusInfo.IsAccident);
				}
				// High Alert replaced with Accident Alert
				else if (
					element.getProperty("HasAlert") == true &&
					BusInfo.HasAlert == true &&
					element.getProperty("IsAccident") == false &&
					BusInfo.IsAccident == true
				) {
					this.PlayAlertSound(BusInfo.Severity, BusInfo.IsAccident);
				}

				element.setProperty("HasAlert", BusInfo.HasAlert);
				element.setProperty("AlertDesc", BusInfo.AlertDesc);
				element.setProperty("IsAccident", BusInfo.IsAccident);
				element.setProperty("Severity", BusInfo.Severity);

				Exists = true;

				//
				// Check Severity Options after updating an existing entry
				// (Ex. Alert turns off or bus stops speeding. How to know to delete it?)
				//
				if (this.BusSeverityOption != 0) {
					if (this.BusSeverityOption == -1 && BusInfo.HasAlert == false) {
						this.lstBusDataPoints.splice(z, 1);
						this.mapRef.map.data.remove(element);
						
						return PositionChanged;
					} else if (this.BusSeverityOption == -2 && BusInfo.HasAlert == true) {
						this.lstBusDataPoints.splice(z, 1);
						this.mapRef.map.data.remove(element);
						
						return PositionChanged;
					} else if (this.BusSeverityOption == 3 && BusInfo.Severity != 3) {
						this.lstBusDataPoints.splice(z, 1);
						this.mapRef.map.data.remove(element);
						
						return PositionChanged;
					} else if (this.BusSeverityOption == 2 && BusInfo.Severity != 2) {
						this.lstBusDataPoints.splice(z, 1);
						this.mapRef.map.data.remove(element);
						
						return PositionChanged;
					} else if (this.BusSeverityOption == 1 && BusInfo.Severity != 1) {
						this.lstBusDataPoints.splice(z, 1);
						this.mapRef.map.data.remove(element);
						
						return PositionChanged;
					} else if (this.BusSeverityOption == -3) {
						if (Number(BusInfo.SpeedMph) < Number(this.SpeedAlertMph)) {
							this.lstBusDataPoints.splice(z, 1);
							this.mapRef.map.data.remove(element);

							return PositionChanged;
						}
					}
				}

				return PositionChanged;
			}
		}

		//
		// If it doesn't exist, draw a new marker
		//
		if (!Exists) {
			//
			// Check Severity Option and return early if the bus doesn't exist
			//
			if (this.BusSeverityOption != 0) {
				if (this.BusSeverityOption == -1 && BusInfo.HasAlert == false) {
					return;
				} else if (this.BusSeverityOption == -2 && BusInfo.HasAlert == true) {
					return;
				} else if (this.BusSeverityOption == 3 && BusInfo.Severity != 3) {
					return;
				} else if (this.BusSeverityOption == 2 && BusInfo.Severity != 2) {
					return;
				} else if (this.BusSeverityOption == 1 && BusInfo.Severity != 1) {
					return;
				} else if (this.BusSeverityOption == -3) {
					if (Number(BusInfo.SpeedMph) < Number(this.SpeedAlertMph)) {
						return;
					}
				}
			}

			let BusLocation: google.maps.LatLng = new google.maps.LatLng(BusInfo.Lat, BusInfo.Long);
			let BusPoint: google.maps.Data.Point = new google.maps.Data.Point(BusLocation);
			let BusFeatureOptions: google.maps.Data.FeatureOptions = {
				geometry: BusPoint,
				properties: {
					Type: "Bus",
					GroupPoint: false,
					BusTextColor: this.BusTextColor,
					BusLabel: NextLabel,
					BusID: BusInfo.BusID,
					BusNbr: BusInfo.BusNbr,
					BusDesc: BusInfo.BusDesc,
					Driver_PersonName: BusInfo.Driver_PersonName,
					BusRouteDesc: BusInfo.BusRouteDesc,
					BusRouteTypeDesc: BusInfo.BusRouteTypeDesc,
					Lat: BusInfo.Lat,
					Long: BusInfo.Long,
					HorizontalAccuracy: BusInfo.HorizontalAccuracy,
					SpeedMph: BusInfo.SpeedMph,
					ShowSpeedWarning: BusInfo.ShowSpeedWarning,
					c_date: BusInfo.c_date,
					c_dateDesc: BusInfo.c_dateDesc,
					StudentCount: BusInfo.StudentCount,
					ToPickupCount: BusInfo.ToPickupCount,
					lstStudentsOnBus: BusInfo.lstStudentsOnBus,
					lstStudentsToPickUp: BusInfo.lstStudentsToPickUp,
					lstSchoolIDs: BusInfo.lstSchoolIDs,
					Selected: AlreadySelected || FromSelector,
					HasAlert: BusInfo.HasAlert,
					AlertDesc: BusInfo.AlertDesc,
					IsAccident: BusInfo.IsAccident,
					Severity: BusInfo.Severity,
					IsMySchool: BusInfo.IsMySchool,
					Map: this.mapRef.map
				},
			};

			let BusFeature: google.maps.Data.Feature = new google.maps.Data.Feature(BusFeatureOptions);
			this.lstBusDataPoints = [...this.lstBusDataPoints, BusFeature];

			// this.mapRef.map.data.add(BusFeature);

			this.PlayAlertSound(BusInfo.Severity, BusInfo.IsAccident);

			return false;
		}
	}

	DeleteUnselectedBuses() {
		for(var x = this.lstBusDataPoints.length - 1; x >= 0; x--){
			var element = this.lstBusDataPoints[x];

			var BusID = element.getProperty("BusID");

			var AlreadySelected = false;
			for (var z = 0; z < this.lstSelectedBuses.length; z++) {
				var next = this.lstSelectedBuses[z];

				if (next.BusID == BusID) {
					AlreadySelected = true;
					break;
				}
			}

			var FromSelector = false;
			if (AlreadySelected == false) {
				for (var z = 0; z < this.BusesFromSelector.length; z++) {
					var next = this.BusesFromSelector[z];

					if (BusID == next) {
						FromSelector = true;
						break;
					}
				}
			}

			if (AlreadySelected == false && FromSelector == false) {
				this.mapRef.map.data.remove(element);
				this.lstBusDataPoints.splice(x, 1);
			}
		}

		this.UpdateBusClusterer();
	}

	DeleteBusesFromOtherSchools() {
		for(var z = this.lstBusDataPoints.length - 1; z >= 0; z--){
			var element = this.lstBusDataPoints[z];

			if (element.getProperty("IsMySchool") == false) {
				this.mapRef.map.data.remove(element);
				this.lstBusDataPoints.splice(z, 1);
			}
		}

		this.UpdateBusClusterer();
	}

	DeleteBusesFromUnselectedSchools() {
		for(var z = this.lstBusDataPoints.length - 1; z >= 0; z--){
			var element = this.lstBusDataPoints[z];

			var lstSchoolIDs = element.getProperty("lstSchoolIDs");

			var ContainsSelected: boolean = false;

			for (var z = 0; z < lstSchoolIDs.length; z++) {
				var next = lstSchoolIDs[z];

				if (next == this.BusSchoolID) {
					ContainsSelected = true;
				}
			}

			if (ContainsSelected == false) {
				this.mapRef.map.data.remove(element);
				this.lstBusDataPoints.splice(z, 1);
			}
		}

		this.UpdateBusClusterer();
	}

	DeleteBusesWithoutAlerts() {
		for(var z = this.lstBusDataPoints.length - 1; z >= 0; z--){
			var element = this.lstBusDataPoints[z];

			if (element.getProperty("HasAlert") == false) {
				this.mapRef.map.data.remove(element);
				this.lstBusDataPoints.splice(z, 1);
			}
		}

		this.UpdateBusClusterer();
	}

	DeleteBusesWithAlerts() {
		for(var z = this.lstBusDataPoints.length - 1; z >= 0; z--){
			var element = this.lstBusDataPoints[z];

			if (element.getProperty("HasAlert") == true) {
				this.mapRef.map.data.remove(element);
				this.lstBusDataPoints.splice(z, 1);
			}
		}

		this.UpdateBusClusterer();
	}

	DeleteBusesWithoutLowAlerts() {
		for(var z = this.lstBusDataPoints.length - 1; z >= 0; z--){
			var element = this.lstBusDataPoints[z];

			if (element.getProperty("Severity") != 3) {
				this.mapRef.map.data.remove(element);
				this.lstBusDataPoints.splice(z, 1);
			}
		}

		this.UpdateBusClusterer();
	}

	DeleteBusesWithoutMediumAlerts() {
		for(var z = this.lstBusDataPoints.length - 1; z >= 0; z--){
			var element = this.lstBusDataPoints[z];

			if (element.getProperty("Severity") != 2) {
				this.mapRef.map.data.remove(element);
				this.lstBusDataPoints.splice(z, 1);
			}
		}

		this.UpdateBusClusterer();
	}

	DeleteBusesWithoutHighAlerts() {
		for(var z = this.lstBusDataPoints.length - 1; z >= 0; z--){
			var element = this.lstBusDataPoints[z];

			if (element.getProperty("Severity") != 1) {
				this.mapRef.map.data.remove(element);
				this.lstBusDataPoints.splice(z, 1);
			}
		}

		this.UpdateBusClusterer();
	}

	DeleteBusesWithoutSpeedAlerts() {
		for(var z = this.lstBusDataPoints.length - 1; z >= 0; z--){
			var element = this.lstBusDataPoints[z];

			if (element.getProperty("ShowSpeedWarning") == false) {
				this.mapRef.map.data.remove(element);
				this.lstBusDataPoints.splice(z, 1);
			}
		}

		this.UpdateBusClusterer();
	}

	DeleteAllBuses() {		
		for(var z = this.lstBusDataPoints.length - 1; z >= 0; z--){
			var element = this.lstBusDataPoints[z];
			this.mapRef.map.data.remove(element);
			this.lstBusDataPoints.splice(z, 1);
		}

		this.UpdateBusClusterer();
	}

	//#endregion

	//#region Student Markers

	CreateStudentMarker(StudentInfo) {
		//
		// Check School Option
		//
		if (this.StudentSchoolOptionID == 1 && StudentInfo.IsMySchool == false) {
			return;
		} else if (this.StudentSchoolOptionID == 2 && StudentInfo.SchoolID != this.StudentSchoolID) {
			return;
		}

		//
		// Check if selected
		//
		var AlreadySelected = false;
		for (var z = 0; z < this.lstSelectedStudents.length; z++) {
			var next = this.lstSelectedStudents[z];

			if (next.Student_PersonID == StudentInfo.Student_PersonID) {
				AlreadySelected = true;
				break;
			}
		}

		var FromSelector = false;
		if (AlreadySelected == false) {
			for (var z = 0; z < this.StudentsFromSelector.length; z++) {
				var next = this.StudentsFromSelector[z];

				if (StudentInfo.Student_PersonID == next) {
					FromSelector = true;
					break;
				}
			}
		}

		var FromBusSelector = false;
		if (AlreadySelected == false && FromSelector == false && this.StudentsFromSelector.length == 0) {
			for (var z = 0; z < this.BusesFromSelector.length; z++) {
				var next = this.BusesFromSelector[z];

				if (StudentInfo.BusID == next) {
					FromBusSelector = true;
					break;
				}
			}
		}

		//
		// Check if it already exists
		//
		var Exists = false;
		for(var z = 0; z < this.lstStudentOnDataPoints.length; z++){
			var element = this.lstStudentOnDataPoints[z];

			if (element.getProperty("BusStudentRideTxnID") == StudentInfo.BusStudentRideTxnID) {
				Exists = true;

				// Update Last Transaction
				if (StudentInfo.LastTransaction == false) {
					element.setProperty("LastTransaction", false);
				}
			}
		}

		if(!Exists){
			for(var z = 0; z < this.lstStudentOffDataPoints.length; z++){
				var element = this.lstStudentOffDataPoints[z];

				if (element.getProperty("BusStudentRideTxnID") == StudentInfo.BusStudentRideTxnID) {
					Exists = true;

					// Update Last Transaction
					if (StudentInfo.LastTransaction == false) {
						element.setProperty("LastTransaction", false);
					}
				}
			}
		}

		if (
			(this.StudentShowLastTransactionOnly == true && StudentInfo.LastTransaction == false) ||
			(this.HideUnselect == true && !(AlreadySelected || FromSelector || FromBusSelector))
		) {
			return;
		}

		if (StudentInfo.EntryTypeID == 1 && this.StudentSwipeOn == false) {
			return;
		} else if (StudentInfo.EntryTypeID == 2 && this.StudentSwipeOff == false) {
			return;
		}

		//
		// Add if it doesn't exist
		//
		if (!Exists) {
			let NextLabel: any = "";

			if (this.ShowStudentName == true) {
				NextLabel += StudentInfo.StudentName + " ";
			}
			if (this.ShowStudentID == true) {
				NextLabel += "(" + StudentInfo.StudentID + ") ";
			}
			if (this.ShowStudentBus == true) {
				NextLabel += "(" + StudentInfo.BusNbr + ") ";
			}
			if (this.ShowStudentCurrentBus == true) {
				NextLabel += "(" + StudentInfo.CurrentBusNbr + ") ";
			}
			if (this.ShowStudentScanTime == true) {
				NextLabel += "(" + StudentInfo.c_dateDesc + ") ";
			}
			if (this.ShowScheduledRider == true) {
				NextLabel += "(" + StudentInfo.isScheduledRiderDesc + ") ";
			}

			let StudentLocation: google.maps.LatLng = new google.maps.LatLng(StudentInfo.Lat, StudentInfo.Long);
			let StudentPoint: google.maps.Data.Point = new google.maps.Data.Point(StudentLocation);
			let StudentFeatureOptions: google.maps.Data.FeatureOptions = {
				geometry: StudentPoint,
				properties: {
					Type: "Student",
					GroupPoint: false,
					BusStudentRideTxnID: StudentInfo.BusStudentRideTxnID,
					StudentTextColor: this.StudentTextColor,
					StudentLabel: NextLabel,
					Driver_PersonID: StudentInfo.Driver_PersonID,
					DriverName: StudentInfo.DriverName,
					Student_PersonID: StudentInfo.Student_PersonID,
					StudentID: StudentInfo.StudentID,
					StudentName: StudentInfo.StudentName,
					BusID: StudentInfo.BusID,
					BusNbr: StudentInfo.BusNbr,
					BusDesc: StudentInfo.BusDesc,
					BusRouteDesc: StudentInfo.BusRouteDesc,
					EntryTypeID: StudentInfo.EntryTypeID,
					EntryTypeDesc: StudentInfo.EntryTypeDesc,
					Lat: StudentInfo.Lat,
					Long: StudentInfo.Long,
					HorizontalAccuracy: StudentInfo.HorizontalAccuracy,
					c_date: StudentInfo.c_date,
					c_dateDesc: StudentInfo.c_dateDesc,
					CurrentBusNbr: StudentInfo.CurrentBusNbr,
					Selected: AlreadySelected || FromSelector || FromBusSelector,
					LastTransaction: StudentInfo.LastTransaction,
					AssignedRoute: StudentInfo.AssignedRoute,
					isScheduledRiderDesc: StudentInfo.isScheduledRiderDesc,
					IsMySchool: StudentInfo.IsMySchool,
					SchoolID: StudentInfo.SchoolID,
					SchoolName: StudentInfo.SchoolName,
					ScanTypeDesc: StudentInfo.ScanTypeDesc,
					Map: this.mapRef.map
				},
			};

			let StudentFeature: google.maps.Data.Feature = new google.maps.Data.Feature(StudentFeatureOptions);

			if(StudentInfo.EntryTypeID == 1){
				this.lstStudentOnDataPoints = [...this.lstStudentOnDataPoints, StudentFeature];
			}
			else{
				this.lstStudentOffDataPoints = [...this.lstStudentOffDataPoints, StudentFeature];
			}

			// this.mapRef.map.data.add(StudentFeature);
		}
	}

	DeleteUnselectedStudents() {
		//
		// Student On
		//
		for(var x = this.lstStudentOnDataPoints.length - 1; x >= 0; x--){
			var element = this.lstStudentOnDataPoints[x];

			var PersonID = element.getProperty("Student_PersonID");
			var BusID = element.getProperty("BusID");

			var AlreadySelected = false;
			for (var z = 0; z < this.lstSelectedStudents.length; z++) {
				var next = this.lstSelectedStudents[z];

				if (next.Student_PersonID == PersonID) {
					AlreadySelected = true;
					break;
				}
			}

			var FromSelector = false;
			// if(AlreadySelected == false && this.ShowSideBar == true){
			if (AlreadySelected == false) {
				for (var z = 0; z < this.StudentsFromSelector.length; z++) {
					var next = this.StudentsFromSelector[z];

					if (PersonID == next) {
						FromSelector = true;
						break;
					}
				}
			}

			var FromBusSelector = false;
			if (AlreadySelected == false && FromSelector == false && this.StudentsFromSelector.length == 0) {
				for (var z = 0; z < this.BusesFromSelector.length; z++) {
					var next = this.BusesFromSelector[z];

					if (BusID == next) {
						FromBusSelector = true;
						break;
					}
				}
			}

			if (AlreadySelected == false && FromSelector == false && FromBusSelector == false) {
				this.lstStudentOnDataPoints.splice(x, 1);
				this.mapRef.map.data.remove(element);
			}
		}


		//
		// Student Off
		//
		for(var x = this.lstStudentOffDataPoints.length - 1; x >= 0; x--){
			var element = this.lstStudentOffDataPoints[x];

			var PersonID = element.getProperty("Student_PersonID");
			var BusID = element.getProperty("BusID");

			var AlreadySelected = false;
			for (var z = 0; z < this.lstSelectedStudents.length; z++) {
				var next = this.lstSelectedStudents[z];

				if (next.Student_PersonID == PersonID) {
					AlreadySelected = true;
					break;
				}
			}

			var FromSelector = false;
			// if(AlreadySelected == false && this.ShowSideBar == true){
			if (AlreadySelected == false) {
				for (var z = 0; z < this.StudentsFromSelector.length; z++) {
					var next = this.StudentsFromSelector[z];

					if (PersonID == next) {
						FromSelector = true;
						break;
					}
				}
			}

			var FromBusSelector = false;
			if (AlreadySelected == false && FromSelector == false && this.StudentsFromSelector.length == 0) {
				for (var z = 0; z < this.BusesFromSelector.length; z++) {
					var next = this.BusesFromSelector[z];

					if (BusID == next) {
						FromBusSelector = true;
						break;
					}
				}
			}

			if (AlreadySelected == false && FromSelector == false && FromBusSelector == false) {
				this.lstStudentOffDataPoints.splice(x, 1);
				this.mapRef.map.data.remove(element);
			}
		}

		this.UpdateStudentOnClusterer();
		this.UpdateStudentOffClusterer();
	}

	DeleteStudentPastTransactions() {
		for(var z = this.lstStudentOnDataPoints.length - 1; z >= 0; z--){
			var element = this.lstStudentOnDataPoints[z];

			if (this.StudentShowLastTransactionOnly == true && element.getProperty("LastTransaction") == false) {
				this.lstStudentOnDataPoints.splice(z, 1);
				this.mapRef.map.data.remove(element);
			}
		}

		for(var z = this.lstStudentOffDataPoints.length - 1; z >= 0; z--){
			var element = this.lstStudentOffDataPoints[z];

			if (this.StudentShowLastTransactionOnly == true && element.getProperty("LastTransaction") == false) {
				this.lstStudentOffDataPoints.splice(z, 1);
				this.mapRef.map.data.remove(element);
			}
		}

		this.UpdateStudentOnClusterer();
		this.UpdateStudentOffClusterer();
	}

	DeleteStudentSwipeOn() {
		for(var z = this.lstStudentOnDataPoints.length - 1; z >= 0; z--){
			var element = this.lstStudentOnDataPoints[z];

			this.lstStudentOnDataPoints.splice(z, 1);
			this.mapRef.map.data.remove(element);
		}

		this.UpdateStudentOnClusterer();
	}

	DeleteStudentSwipeOff() {
		for(var z = this.lstStudentOffDataPoints.length - 1; z >= 0; z--){
			var element = this.lstStudentOffDataPoints[z];

			this.lstStudentOffDataPoints.splice(z, 1);
			this.mapRef.map.data.remove(element);
		}

		this.UpdateStudentOffClusterer();
	}

	DeleteAllStudents() {
		this.DeleteStudentSwipeOn();
		this.DeleteStudentSwipeOff();
	}

	DeleteStudentsFromOtherSchools() {
		for(var z = this.lstStudentOnDataPoints.length - 1; z >= 0; z--){
			var element = this.lstStudentOnDataPoints[z];

			if (element.getProperty("IsMySchool") == false) {
				this.lstStudentOnDataPoints.splice(z, 1);
				this.mapRef.map.data.remove(element);
			}
		}

		for(var z = this.lstStudentOffDataPoints.length - 1; z >= 0; z--){
			var element = this.lstStudentOffDataPoints[z];

			if (element.getProperty("IsMySchool") == false) {
				this.lstStudentOffDataPoints.splice(z, 1);
				this.mapRef.map.data.remove(element);
			}
		}

		this.UpdateStudentOnClusterer();
		this.UpdateStudentOffClusterer();
	}

	DeleteStudentsFromUnselectedSchools() {
		for(var z = this.lstStudentOnDataPoints.length - 1; z >= 0; z--){
			var element = this.lstStudentOnDataPoints[z];

			if (element.getProperty("SchoolID") != this.StudentSchoolID) {
				this.lstStudentOnDataPoints.splice(z, 1);
				this.mapRef.map.data.remove(element);
			}
		}

		for(var z = this.lstStudentOffDataPoints.length - 1; z >= 0; z--){
			var element = this.lstStudentOffDataPoints[z];

			if (element.getProperty("SchoolID") != this.StudentSchoolID) {
				this.lstStudentOffDataPoints.splice(z, 1);
				this.mapRef.map.data.remove(element);
			}
		}

		this.UpdateStudentOnClusterer();
		this.UpdateStudentOffClusterer();
	}

	//#endregion

	//#region Style and Listeners

	UpdateMapStylesAndListeners() {
		//
		// Only Run 1 time
		//
		if (this.InitStylesAndListeners == true) {
			return;
		}

		this.InitStylesAndListeners = true;

		/////////////////////////////////////////////////////
		// Styling
		/////////////////////////////////////////////////////

		this.mapRef.map.data.setStyle(function (feature) {
			var Type = feature.getProperty("Type");

			var ParentPath: any = "assets/images/BusTrackerMap/BusIconsV4/";

			if (Type == "Bus") {
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("BusLabel");
				// var NextColor: any = "Black";
				var NextColor: any = feature.getProperty("BusTextColor");

				if (feature.getProperty("HasAlert") == true || feature.getProperty("ShowSpeedWarning") == true) {
					NextColor = "Red";

					// if(feature.getProperty('Selected') == true){
					//   // NextColor = "Orange";
					// }
					// else{
					//   NextColor = "Red";
					// }
				}
				// else{
				//   NextColor = "Black";

				//   // if(feature.getProperty('Selected') == true){
				//   //   // NextColor = "Yellow";
				//   // }
				//   // else{
				//   //   // NextColor = "Blue";
				//   // }
				// }

				nextLabel = {
					text: NextText,
					color: NextColor,
					fontWeight: "Bold",
				};

				var iconPath: any = "";
				var Severity: any = Number(feature.getProperty("Severity"));

				var BusLabelX: number = 25;
				var BusLabelY: number = 60;

				if(feature.getProperty("GroupPoint") == false) {
					if (Severity == 0) {
						if (feature.getProperty("Selected") == true) {
							iconPath = ParentPath + "Bus_DefaultSelected.png";
						} else {
							iconPath = ParentPath + "Bus_Default.png";
						}
					} else if (Severity == 3) {
						if (feature.getProperty("Selected") == true) {
							iconPath = ParentPath + "Bus_LowAlertSelected.png";
						} else {
							iconPath = ParentPath + "Bus_LowAlert.png";
						}
					} else if (Severity == 2) {
						if (feature.getProperty("Selected") == true) {
							iconPath = ParentPath + "Bus_MediumAlertSelected.png";
						} else {
							iconPath = ParentPath + "Bus_MediumAlert.png";
						}
					} else if (Severity == 1) {
						if (feature.getProperty("Selected") == true) {
							iconPath = ParentPath + "Bus_HighAlertSelected.png";
						} else {
							iconPath = ParentPath + "Bus_HighAlert.png";
						}
					}
				}
				else{
					iconPath = ParentPath + "Bus_Group.png";
				}

				if (NextText != "") {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: BusLabelX,
								y: BusLabelY,
							},
						},
						label: nextLabel,
						title: feature.getProperty("BusNbr"),
					};
				} else {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: BusLabelX,
								y: BusLabelY,
							},
						},
						title: feature.getProperty("BusNbr"),
					};
				}
			} else if (Type == "Student") {
				var iconPath: any = "/assets/images/BusTrackerMap/student_icon.png";
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("StudentLabel");
				// var NextColor: any = "Blue";
				var NextColor: any = feature.getProperty("StudentTextColor");

				var EntryTypeID = feature.getProperty("EntryTypeID");
				var Selected = feature.getProperty("Selected");

				if (EntryTypeID == 1) {
					if(feature.getProperty("GroupPoint") == false){
						if (Selected) {
							// NextColor = "DarkGoldenRod";
							iconPath = ParentPath + "StudentOnSelected.png";
						} else {
							// NextColor = "Green";
							iconPath = ParentPath + "StudentOn.png";
						}
					}
					else{
						iconPath = ParentPath + "StudentOn_Group.png";
					}
				} else if (EntryTypeID == 2) {
					if(feature.getProperty("GroupPoint") == false){
						if (Selected) {
							// NextColor = "DarkOrange";
							iconPath = ParentPath + "StudentOffSelected.png";
						} else {
							// NextColor = "DarkRed";
							iconPath = ParentPath + "StudentOff.png";
						}
					}
					else{
						iconPath = ParentPath + "StudentOff_Group.png";
					}
				}

				if (feature.getProperty("LastTransaction") == true) {
					NextText += "*";
				}

				nextLabel = {
					text: NextText,
					color: NextColor,
					fontWeight: "Bold",
				};

				if (NextText != "") {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 17.5,
								y: -10,
							},
						},
						label: nextLabel,
						title: feature.getProperty("StudentName"),
					};
				} else {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 17.5,
								y: -10,
							},
						},
						title: feature.getProperty("StudentName"),
					};
				}
			} else if (Type == "GeoFence") {
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("Label");
				// var NextColor: any = feature.getProperty("FillColor");

				nextLabel = {
					text: NextText,
					color: "Black", //NextColor,
					fontWeight: "Bold",
				};

				var NextStrokeColor: any = "Black";
				var NextStrokeWeight: any = 1;

				if (feature.getProperty("Selected") == true) {
					NextStrokeColor = "Blue";
					NextStrokeWeight = 4;
				}

				if (NextText != "") {
					return {
						label: nextLabel,
						title: feature.getProperty("GeoFenceID"),
						strokeOpacity: 0.5,
						strokeColor: NextStrokeColor,
						strokeWeight: NextStrokeWeight,
						fillColor: feature.getProperty("FillColor"),
						fillOpacity: feature.getProperty("AlphaChannel"),
					};
				} else {
					return {
						title: feature.getProperty("GeoFenceID"),
						strokeOpacity: 0.5,
						strokeColor: NextStrokeColor,
						strokeWeight: NextStrokeWeight,
						fillColor: feature.getProperty("FillColor"),
						fillOpacity: feature.getProperty("AlphaChannel"),
					};
				}
			}
		});

		/////////////////////////////////////////////////////

		/////////////////////////////////////////////////////
		// Event Listeners
		/////////////////////////////////////////////////////

		this.mapRef.map.data.addListener("rightclick", (event) => {
			/////////////////////////////////////////////////////////////////////////////////////////////////////
			// Open Info Window
			/////////////////////////////////////////////////////////////////////////////////////////////////////
			
			var GroupPoint: boolean = event.feature.getProperty("GroupPoint"); 
			if(GroupPoint == true){
				return;
			}

			let infoWindow: google.maps.InfoWindow = new google.maps.InfoWindow();

			var type: any = event.feature.getProperty("Type");

			var latLng: google.maps.LatLng;

			if (type == "Bus") {
				infoWindow.setContent(this.GetBusPopup(event.feature, infoWindow));
				latLng = new google.maps.LatLng({
					lat: event.feature.getProperty("Lat"),
					lng: event.feature.getProperty("Long"),
				});
			} else if (type == "Student") {
				infoWindow.setContent(this.GetStudentPopup(event.feature, infoWindow));

				//
				// If spiderfied, display window near new position
				//
				var Point: google.maps.Data.Point = event.feature.getGeometry();
				var latLng: google.maps.LatLng = Point.get();
			} else if (type == "GeoFence") {
				infoWindow.setContent(this.GetGeoFencePopup(event.feature));
				latLng = new google.maps.LatLng({
					lat: event.feature.getProperty("Lat"),
					lng: event.feature.getProperty("Long"),
				});
			}

			infoWindow.setOptions({
				// position: { lat: event.feature.getProperty("Lat"), lng: event.feature.getProperty("Long") }
				position: latLng,
			});

			infoWindow.open(this.mapRef.map);

			/////////////////////////////////////////////////////////////////////////////////////////////////////
		});

		this.mapRef.map.data.addListener("click", (event) => {
			//
			// Check if student
			//
			if (event.feature.getProperty("Type") == "Student") {
				//
				// First Check if it is overlapping other students
				//

				var Overlap: any = false;
				for (var z = 0; z < this.lstOverlaps.length; z++) {
					var next = this.lstOverlaps[z];

					if (next.getProperty("BusStudentRideTxnID") == event.feature.getProperty("BusStudentRideTxnID")) {
						Overlap = true;
						break;
					}
				}

				//
				// If overlapping and not spiderfied already
				// then spiderfy
				//
				if (!Overlap && event.feature.getProperty("BusStudentRideTxnID") != this.SpiderfyBusStudentRideTxnID) {
					//
					// Unspiderfy existing web
					//
					if (Number(this.lstOverlaps.length) > 0) {
						this.StudentUnSpiderfy();
					}

					//
					// Update overlap list
					//
					this.SpiderfyUpdateOverlapList(event);

					//
					// If there are overlaps, spiderfy
					//
					if (this.lstOverlaps.length > 0) {
						this.StudentSpiderfy(event);
					}
					//
					// If normal point then select like normal
					//
					else {
						this.SelectStudent(event);
					}
				}
				//
				// Else select or deselect (Point is part of current spider web, either center or expanded point)
				//
				else {
					this.SelectStudent(event);
				}
			}
			//
			// Not student
			//
			else {
				//
				// Close spiderfy if opened
				//
				if (this.lstOverlaps.length > 0) {
					this.StudentUnSpiderfy();
				}

				//
				// Check if other item was clicked on
				//
				if (event.feature.getProperty("Type") == "Bus") {
					/////////////////////////////////////////////////////////////////////////////////////////////////////
					// Select or deselect Bus
					/////////////////////////////////////////////////////////////////////////////////////////////////////

					var tempSelected = event.feature.getProperty("Selected");

					var NewSelected = true;
					if (tempSelected == true) {
						NewSelected = false;
					}

					event.feature.setProperty("Selected", NewSelected);

					var BusID = event.feature.getProperty("BusID");

					if (NewSelected == true) {
						for (var z = 0; z < this.lstBusPositions.length; z++) {
							var next = this.lstBusPositions[z];

							if (next.BusID == BusID) {
								this.lstSelectedBuses = [...this.lstSelectedBuses, next];
								break;
							}
						}

						// this.mapRef.map.setCenter( { lat: event.feature.getProperty("Lat"), lng: event.feature.getProperty("Long") } );
					} else {
						this.lstSelectedBuses = this.lstSelectedBuses.filter((bus) => bus.BusID != BusID);
					}

					/////////////////////////////////////////////////////////////////////////////////////////////////////
				}
			}
		});

		this.UpdateAll();

		/////////////////////////////////////////////////////
	}

	//#endregion

	//#region Popups
	GetBusPopup(BusFeature, infoWindow) {
		//Start loading photo and update when it's done
		this.LoadBusStudentPhotos(BusFeature, infoWindow);

		//Return popup with loading message
		return this.BusStudentListImageLoading(BusFeature);
	}

	LoadBusStudentPhotos(BusFeature, infoWindow) {
		var lstPIDs: number[] = [];

		var lstStudents = BusFeature.getProperty("lstStudentsOnBus");

		for (var z = 0; z < lstStudents.length; z++) {
			var next = lstStudents[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		var parms: BTBusGetPersonPhotosRequest = {
			lstPersonIDs: lstPIDs,
		};

		var result = this.mapService.BusGetPersonPhotos(parms);
		result.subscribe(
			(response) => {
				//
				// Update window when the person images have loaded
				//
				infoWindow.setContent(this.BusStudentList(response, BusFeature));
			},
			(error) => {}
		);
	}

	//
	// Main part without student list
	//
	GetBusPopupMain(BusFeature): string {
		var htmlText: any = "";

		//
		// Main Info
		//
		htmlText +=
			`
      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
        <label style="margin: 0px;">Bus Number:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusNbr") +
			`</p>

        <label style="margin: 0px;">Bus Description:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Driver:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("Driver_PersonName") +
			`</p>

        <label style="margin: 0px;">Current Route:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusRouteDesc") +
			`</p>

        <label style="margin: 0px;">Route Type:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusRouteTypeDesc") +
			`</p>

        <label style="margin: 0px;">Current Speed:</label> `;

		if (BusFeature.getProperty("ShowSpeedWarning") == true) {
			htmlText += `<p style="margin: 0px; color: red;">` + BusFeature.getProperty("SpeedMph") + ` mph</p>`;
		} else {
			htmlText += `<p style="margin: 0px; color: blue;">` + BusFeature.getProperty("SpeedMph") + ` mph</p>`;
		}

		htmlText +=
			`<label style="margin: 0px;">Position Last Updated:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("c_dateDesc") +
			`</p>

        <label style="margin: 0px;">Students on Bus:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("StudentCount") +
			`</p>
        
        <label style="margin: 0px;">Students to Pick Up:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("ToPickupCount") +
			`</p>

        <label style="margin: 0px;">Latitude:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("Lat") +
			`</p>

        <label style="margin: 0px;">Longitude:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("Long") +
			`</p>

        <label style="margin: 0px;">Accuracy (ft, lower is better):</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("HorizontalAccuracy") +
			`</p>`;

		if (BusFeature.getProperty("HasAlert") == true) {
			htmlText +=
				`
        <label style="margin: 0px;">Current Alert:</label>
        <p style="margin: 0px; color: Red;">` +
				BusFeature.getProperty("AlertDesc") +
				`</p>
      `;
		}

		htmlText += `</div>
    `;

		return htmlText;
	}

	//
	// Student list while the images are still loading
	//
	BusStudentListImageLoading(BusFeature) {
		var htmlText: any = "";

		//
		// Get main body
		//
		htmlText = this.GetBusPopupMain(BusFeature);

		//
		// List of Students
		//
		if (BusFeature.getProperty("StudentCount") > 0) {
			htmlText += `
        <style>
          table {
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
          }

          td, th {
            border: 1px solid #dddddd;
            text-align: left;
            padding: 8px;
          }

          tr:nth-child(even) {
            background-color: #dddddd;
          }
        </style>

        <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
          <label>Students on Bus:</label>
          <table>
            <tr>
              <th>Photo</th>
              <th>Student ID</th>
              <th>Name</th>
            </tr>`;

			//
			// Add a row for each student in the list
			//
			var lstStudents = BusFeature.getProperty("lstStudentsOnBus");
			for (var z = 0; z < lstStudents.length; z++) {
				var next = lstStudents[z];

				htmlText +=
					`
          <tr` +
					(next.AssignedRoute == false ? ` style="color: Red;"` : ``) +
					`>
            <td>...Image Loading</td>
            <td>` +
					next.StudentID +
					`</td>
            <td>` +
					next.StudentName +
					(next.AssignedRoute == false ? ` <span style="color: Red;">*</span>` : ``) +
					`</td>
          </tr>
        `;
			}

			htmlText += `
          </table>
        </div>
      `;
		}

		// if(BusFeature.getProperty("ToPickupCount") > 0){

		//   htmlText += `
		//     <style>
		//       table {
		//         font-family: arial, sans-serif;
		//         border-collapse: collapse;
		//         width: 100%;
		//       }

		//       td, th {
		//         border: 1px solid #dddddd;
		//         text-align: left;
		//         padding: 8px;
		//       }

		//       tr:nth-child(even) {
		//         background-color: #dddddd;
		//       }
		//     </style>

		//     <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
		//       <label>Students Assigned Route <span style="color: Red;">(NOT ON BUS)</span>:</label>
		//       <table>
		//         <tr>
		//           <th>Student ID</th>
		//           <th>Name</th>
		//         </tr>`;

		//   //
		//   // Add a row for each student in the list
		//   //
		//   var lstToPickUp = BusFeature.getProperty("lstStudentsToPickUp");
		//   for(var z = 0; z < lstToPickUp.length; z++){
		//     var next = lstToPickUp[z];

		//     htmlText +=  `
		//       <tr>
		//         <td>` + next.StudentID + `</td>
		//         <td>` + next.StudentName + `</td>
		//       </tr>
		//     `;
		//   }

		//   htmlText +=`
		//       </table>
		//     </div>
		//   `;
		// }

		return htmlText;
	}

	//
	// Student list after the images are loaded
	//
	BusStudentList(lstImages, BusFeature) {
		var htmlText: any = "";

		htmlText = this.GetBusPopupMain(BusFeature);

		//
		// List of Students
		//
		if (BusFeature.getProperty("StudentCount") > 0) {
			htmlText += `
        <style>
          table {
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
          }

          td, th {
            border: 1px solid #dddddd;
            text-align: left;
            padding: 8px;
          }

          tr:nth-child(even) {
            background-color: #dddddd;
          }
        </style>

        <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
          <label>Students on Bus:</label>
          <table>
            <tr>
              <th>Photo</th>
              <th>Student ID</th>
              <th>Name</th>
            </tr>`;

			//
			// Add a row for each student in the list
			//
			var lstStudents = BusFeature.getProperty("lstStudentsOnBus");
			for (var z = 0; z < lstStudents.length; z++) {
				var next = lstStudents[z];

				var PersonPhoto = "";
				for (var i = 0; i < lstImages.length; i++) {
					var nextImage = lstImages[i];

					if (nextImage.PersonID == next.PersonID) {
						PersonPhoto = nextImage.PersonPhotoData;
					}
				}

				htmlText +=
					`
          <tr` +
					(next.AssignedRoute == false ? ` style="color: Red;"` : ``) +
					`>
            <td>
              <div style="border: 1px solid black; max-width: 200px; max-height: 200px;">
                <img style="max-width: 200px; max-height: 200px;" src="` +
					PersonPhoto +
					`">
              </div>
            </td>
            <td>` +
					next.StudentID +
					`</td>
            <td>` +
					next.StudentName +
					(next.AssignedRoute == false ? ` <span style="color: Red;">*</span>` : ``) +
					`</td>
          </tr>
        `;
			}

			htmlText += `
          </table>
        </div>
      `;
		}

		// if(BusFeature.getProperty("ToPickupCount") > 0){

		//   htmlText += `
		//     <style>
		//       table {
		//         font-family: arial, sans-serif;
		//         border-collapse: collapse;
		//         width: 100%;
		//       }

		//       td, th {
		//         border: 1px solid #dddddd;
		//         text-align: left;
		//         padding: 8px;
		//       }

		//       tr:nth-child(even) {
		//         background-color: #dddddd;
		//       }
		//     </style>

		//     <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
		//       <label>Students Assigned Route <span style="color: Red;">(NOT ON BUS)</span>:</label>
		//       <table>
		//         <tr>
		//           <th>Student ID</th>
		//           <th>Name</th>
		//         </tr>`;

		//   //
		//   // Add a row for each student in the list
		//   //
		//   var lstToPickUp = BusFeature.getProperty("lstStudentsToPickUp");
		//   for(var z = 0; z < lstToPickUp.length; z++){
		//     var next = lstToPickUp[z];

		//     htmlText +=  `
		//       <tr>
		//         <td>` + next.StudentID + `</td>
		//         <td>` + next.StudentName + `</td>
		//       </tr>
		//     `;
		//   }

		//   htmlText +=`
		//       </table>
		//     </div>
		//   `;
		// }

		return htmlText;
	}

	//
	// Pass info window so the image can be updated after it loads
	// (It loads 1 photo at a time)
	//
	GetStudentPopup(StudentFeature, infoWindow): string {
		//Start loading photo and update when it's done
		this.LoadStudentPhoto(StudentFeature, infoWindow);

		//Return popup with loading message
		return this.FinishGetStudentPopupImageLoading(StudentFeature);
	}

	//
	// Pass Student Feature and Info window for updating after the photo loads
	//
	LoadStudentPhoto(StudentFeature, infoWindow) {
		var result = this.mapService.PersonGetImage(StudentFeature.getProperty("Student_PersonID"));
		result.subscribe(
			(response) => {
				var img = response[0];

				//
				// Update window when the person's image has loaded
				//
				infoWindow.setContent(this.FinishGetStudentPopup(StudentFeature, img));
			},
			(error) => {}
		);
	}

	//
	// Set top part of popup to loading message
	//
	FinishGetStudentPopupImageLoading(StudentFeature) {
		var htmlText: any = "";

		//
		// Image
		//
		htmlText += `
      <div style="text-align: center; width: fit-content; margin-left: auto; margin-right: auto;">
        <label style="margin-bottom: 10px;">...Image Loading</label>
      </div>
    `;

		//
		// Combine with bottom of popup
		//
		return this.FinishGetPopupMain(StudentFeature, htmlText);
	}

	//
	// Set top part of popup to student's image
	//
	FinishGetStudentPopup(StudentFeature, img) {
		var htmlText: any = "";

		//
		// Image
		//
		htmlText +=
			`
      <div style="text-align: center; width: fit-content; margin-left: auto; margin-right: auto;">
        <div style="border: 1px solid black; max-width: 200px; max-height: 200px; margin-bottom: 10px;">
          <img style="max-width: 200px; max-height: 200px;" src="` +
			img +
			`">
        </div>
      </div>
    `;

		//
		// Combine with bottom of popup
		//
		return this.FinishGetPopupMain(StudentFeature, htmlText);
	}

	//
	// Main part of student popup (Normal popup from 10.11)
	//
	FinishGetPopupMain(StudentFeature, htmlText) {
		htmlText +=
			`
      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
      
        <label style="margin: 0px;">Student ID:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("StudentID") +
			`</p>

        <label style="margin: 0px;">Student Name:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("StudentName") +
			`</p>

        <label style="margin: 0px;">School:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("SchoolName") +
			`</p>

        <label style="margin: 0px;">Student Currently on Bus:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("CurrentBusNbr") +
			`</p>
        
        <label style="margin: 0px;">Bus Number:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("BusNbr") +
			`</p>

        <label style="margin: 0px;">Bus Description:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Driver:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("DriverName") +
			`</p>

        <label style="margin: 0px;">Route Description:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("BusRouteDesc") +
			`</p>

        <label style="margin: 0px;">Entry/Exit Type:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("EntryTypeDesc") +
			`</p>

        <label style="margin: 0px;">Scan Time:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("c_dateDesc") +
			`</p>

        <label style="margin: 0px;">Last Known Transaction:</label>`;

		if (StudentFeature.getProperty("LastTransaction") == true) {
			htmlText += `<p style="margin: 0px; color: Blue;">Yes</p>`;
		} else {
			htmlText += `<p style="margin: 0px; color: Blue;">No</p>`;
		}

		htmlText += `<label style="margin: 0px;">Scheduled Rider:</label>`;

		if (StudentFeature.getProperty("AssignedRoute") == true) {
			htmlText += `<p style="margin: 0px; color: Blue;">Yes</p>`;
		} else {
			htmlText += `<p style="margin: 0px; color: Red;">No (added manually)</p>`;
		}

		htmlText +=
			`
        <label style="margin: 0px;">Latitude:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("Lat") +
			`</p>

        <label style="margin: 0px;">Longitude:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("Long") +
			`</p>

        <label style="margin: 0px;">Accuracy (ft, lower is better):</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("HorizontalAccuracy") +
			`</p>

        <label style="margin: 0px;">Scan Type:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("ScanTypeDesc") +
			`</p>

      </div>
    `;

		return htmlText;
	}

	GetGeoFencePopup(GeoFenceInfo) {
		var htmlText: any = "";

		htmlText +=
			`
      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
        
        <label style="margin: 0px;">Description:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeoFenceDesc") +
			`</p>

        <label style="margin: 0px;">Used By:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Trigger Type Code:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeofenceTriggerTypeCD") +
			`</p>

        <label style="margin: 0px;">Trigger Type Description:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeofenceTriggerTypeDesc") +
			`</p>

        <label style="margin: 0px;">Severity:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("SeverityDesc") +
			`</p>

        <label style="margin: 0px;">Comments:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("AlertComments") +
			`</p>

        <label style="margin: 0px;">Active:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("ActiveDesc") +
			`</p>

      </div>
    `;

		return htmlText;
	}

	//#endregion

	//#region Spiderfy

	SelectStudent(event) {
		/////////////////////////////////////////////////////////////////////////////////////////////////////
		// Select or deselect student
		/////////////////////////////////////////////////////////////////////////////////////////////////////

		var tempSelected = event.feature.getProperty("Selected");

		var NewSelected = true;
		if (tempSelected == true) {
			NewSelected = false;
		}

		event.feature.setProperty("Selected", NewSelected);

		var Student_PersonID = event.feature.getProperty("Student_PersonID");

		if (NewSelected == true) {
			for (var z = 0; z < this.lstStudentPositions.length; z++) {
				var next = this.lstStudentPositions[z];

				if (next.Student_PersonID == Student_PersonID) {
					this.lstSelectedStudents = [...this.lstSelectedStudents, next];
					break;
				}
			}

			// this.mapRef.map.setCenter( { lat: event.feature.getProperty("Lat"), lng: event.feature.getProperty("Long") } );
		} else {
			this.lstSelectedStudents = this.lstSelectedStudents.filter((student) => student.Student_PersonID != Student_PersonID);
		}

		/////////////////////////////////////////////////////////////////////////////////////////////////////
	}

	SpiderfyUpdateOverlapList(event) {
		//////////////////////////////////////////////////////////////////
		//#region Get list of overlapping features (on Data Layer)
		//////////////////////////////////////////////////////////////////

		var scale = 1 << this.mapRef.map.getZoom();

		var WorldCoordinate = this.project(
			new google.maps.LatLng({
				lat: event.feature.getProperty("Lat"),
				lng: event.feature.getProperty("Long"),
			})
		);
		var PixelCoordinate = new google.maps.Point(Math.floor(WorldCoordinate.x * scale), Math.floor(WorldCoordinate.y * scale));

		this.lstOverlaps = [];

		this.mapRef.map.data.forEach((element) => {
			if (element.getProperty("Type") == "Student" && element.getProperty("GroupPoint") == false) {
				var NextWorldCoordinate = this.project(
					new google.maps.LatLng({
						lat: element.getProperty("Lat"),
						lng: element.getProperty("Long"),
					})
				);
				var NextPixelCoordinate = new google.maps.Point(Math.floor(NextWorldCoordinate.x * scale), Math.floor(NextWorldCoordinate.y * scale));

				var DistanceSq = Math.pow(NextPixelCoordinate.x - PixelCoordinate.x, 2) + Math.pow(NextPixelCoordinate.y - PixelCoordinate.y, 2);

				if (
					DistanceSq < Math.pow(this.Tolerance, 2) &&
					element.getProperty("BusStudentRideTxnID") != event.feature.getProperty("BusStudentRideTxnID")
				) {
					var nextEntry = element;
					// {
					//   Feature: element,
					//   DistanceSq: DistanceSq
					// };

					this.lstOverlaps = [...this.lstOverlaps, nextEntry];
				}
			}
		});

		//
		// Sort by distance ascending
		//
		// this.lstOverlaps.sort((a, b) => a.DistanceSq - b.DistanceSq);
		// for(var z = 0; z < this.lstOverlaps.length; z++){
		//   var next = this.lstOverlaps[z];
		//   this.lstOverlaps[z] = next.Feature;
		// }

		//#endregion
		//////////////////////////////////////////////////////////////////

		return;
	}

	StudentSpiderfy(event) {
		this.SpiderfyBusStudentRideTxnID = event.feature.getProperty("BusStudentRideTxnID");

		//////////////////////////////////////////////////////////////////
		//#region Move overlapping points out of the way
		//////////////////////////////////////////////////////////////////

		for (var z = 0; z < this.lstOverlaps.length; z++) {
			var next = this.lstOverlaps[z];

			next.setGeometry(this.SpiderGeometry(event.feature, next, z));
		}

		//#endregion
		//////////////////////////////////////////////////////////////////
	}

	//
	// Return a google.maps.Data.Point for spiderfying
	//
	SpiderGeometry(Origin, feature, Index) {
		//
		// NEW, Circle from origin
		//

		var Layer: any = Math.floor(Index / this.SpiderMaxLegs);

		var CurrentZoom: any = this.mapRef.map.getZoom();
		// var ZoomCoefficient: any = this.ZoomCoefficient//1 // (Math.pow(this.ZoomCoefficient, CurrentZoom));

		// var Length = (Layer + 1) * (this.SpiderLegLength + this.ZoomCoefficient);
		// var Length = (Layer + 1) * this.SpiderLegLength;

		var M_PX = 591657550.5 / Math.pow(2, CurrentZoom);
		var Length = (Layer + 1) * this.ZoomCoefficient * M_PX;

		var NewLat: any = Origin.getProperty("Lat") + Length * Math.cos((Index * 2 * Math.PI) / this.SpiderMaxLegs);
		var NewLong: any = Origin.getProperty("Long") + Length * Math.sin((Index * 2 * Math.PI) / this.SpiderMaxLegs);

		//
		// OLD
		//
		// Line from original location to new location
		//
		// this.overlays.push(new google.maps.Polyline({
		//   path: [
		//     {lat: feature.getProperty("Lat"), lng: feature.getProperty("Long")},
		//     {lat: NewLat, lng: NewLong}
		//   ],
		//   strokeColor: Index % 2 == 0 ? "#FF0000" : "#0000FF",
		//   strokeOpacity: 1.0,
		//   strokeWeight: 2,
		// }))

		//
		// NEW
		//
		// Make web connecting points in spiral
		//
		if (this.overlays.length > 0) {
			var lastPath = this.overlays[this.overlays.length - 1].getPath();
			var lastPoint = lastPath.getAt(1);

			this.overlays.push(
				new google.maps.Polyline({
					path: [
						{ lat: lastPoint.lat(), lng: lastPoint.lng() },
						{ lat: NewLat, lng: NewLong },
					],
					strokeColor: "#FF0000", //Index % 2 == 0 ? "#FF0000" : "#0000FF",
					strokeOpacity: 1.0,
					strokeWeight: 2,
				})
			);
		} else {
			this.overlays.push(
				new google.maps.Polyline({
					path: [
						{
							lat: Origin.getProperty("Lat"),
							lng: Origin.getProperty("Long"),
						},
						{ lat: NewLat, lng: NewLong },
					],
					strokeColor: Index % 2 == 0 ? "#FF0000" : "#0000FF",
					strokeOpacity: 1.0,
					strokeWeight: 2,
				})
			);
		}

		return new google.maps.Data.Point(
			new google.maps.LatLng({
				lat: NewLat,
				lng: NewLong,
			})
		);
	}

	StudentUnSpiderfy() {
		this.SpiderfyBusStudentRideTxnID = -1;
		this.overlays = []; //Delete lines that show the position changed (NOTE: DOESN'T AFFECT ACTUAL OVERLAYS, they're data layer objects)

		for (var z = 0; z < this.lstOverlaps.length; z++) {
			var next = this.lstOverlaps[z];

			next.setGeometry(
				new google.maps.Data.Point(
					new google.maps.LatLng({
						lat: next.getProperty("Lat"),
						lng: next.getProperty("Long"),
					})
				)
			);
		}

		this.lstOverlaps = [];
	}

	// The mapping between latitude, longitude and pixels is defined by the web
	// mercator projection.
	project(latLng: google.maps.LatLng) {
		let siny = Math.sin((latLng.lat() * Math.PI) / 180);

		// Truncating to 0.9999 effectively limits latitude to 89.189. This is
		// about a third of a tile past the edge of the world tile.
		siny = Math.min(Math.max(siny, -0.9999), 0.9999);

		return new google.maps.Point(this.TILE_SIZE * (0.5 + latLng.lng() / 360), this.TILE_SIZE * (0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI)));
	}

	// GetRandomColor(){
	//   var r = Math.random() * 255;
	//   var g = Math.random() * 255;
	//   var b = Math.random() * 255;

	//   return 'rgb(' + r + "," + g + "," + b + ")";
	//   // return '#42A5F5';
	// }

	DebugGetZoom() {
		var ans = -1;

		try {
			ans = this.mapRef.map.getZoom();
		} catch (e) {
			e.toString();
			ans = -1;
		}

		return ans;
	}

	//#endregion

	//#region Preferences
	UpdatePreferences() {
		let BT_MapOptions: any = {
			ShowAllBuses: this.ShowAllBuses,
			BusSchoolOptionID: this.BusSchoolOptionID,
			StudentSchoolOptionID: this.StudentSchoolOptionID,
			BusSchoolID: this.BusSchoolID,
			StudentSchoolID: this.StudentSchoolID,
			StudentSwipeOn: this.StudentSwipeOn,
			StudentSwipeOff: this.StudentSwipeOff,
			StudentShowLastTransactionOnly: this.StudentShowLastTransactionOnly,
			ShowTraffic: this.ShowTraffic,
			ShowBusNumber: this.ShowBusNumber,
			ShowStudentCount: this.ShowStudentCount,
			ShowSpeed: this.ShowSpeed,
			ShowAlert: this.ShowAlert,
			ShowBusScanTime: this.ShowBusScanTime,
			ShowStudentName: this.ShowStudentName,
			ShowStudentID: this.ShowStudentID,
			ShowStudentCurrentBus: this.ShowStudentCurrentBus,
			ShowStudentBus: this.ShowStudentBus,
			ShowStudentScanTime: this.ShowStudentScanTime,
			ShowScheduledRider: this.ShowScheduledRider,
			HideUnselect: this.HideUnselect,
			BusTextColor: this.BusTextColor,
			StudentTextColor: this.StudentTextColor,
			SpeedAlertMph: this.SpeedAlertMph,
			ShowGeoFences: this.ShowGeoFences,
			HideInactiveGeoFences: this.HideInactiveGeoFences,
			BusSeverityOption: this.BusSeverityOption,
		};

		this.localService.setItem("BT_MapOptions", BT_MapOptions);
	}
	//#endregion

	//#region Sounds
	dataURIToMP3Blob(val) {
		const byteString = window.atob(val);
		const arrayBuffer = new ArrayBuffer(byteString.length);
		const int8Array = new Uint8Array(arrayBuffer);
		for (let i = 0; i < byteString.length; i++) {
			int8Array[i] = byteString.charCodeAt(i);
		}
		const blob = new Blob([int8Array], { type: "audio/mpeg" });
		return blob;
	}

	PauseSound() {
		if (this.audio.src != null && this.audio.currentTime > 0) {
			this.audio.pause();
			this.audio.currentTime = 0;
		}
	}

	PlayAlertSound(Severity, IsAccident) {
		if (this.PlaySounds == false) {
			return;
		}

		var a = new Audio();
		var src: any = null;

		if (Severity == 1) {
			if (IsAccident == true) {
				src = this.AccidentHighSound;
			} else {
				src = this.HighSeveritySound;
			}
		} else if (Severity == 2) {
			src = this.MediumSeveritySound;
		} else if (Severity == 3) {
			src = this.LowSeveritySound;
		}

		if (src != null) {
			a.src = src;
			a.cloneNode();
			a.load();
			a.play();
		}
	}

	//#endregion

	//#region Loading
	IsLoading() {
		return (
			this.PrefLoading == true ||
			this.TopBarLoading == true ||
			this.GeoFenceLoading == true ||
			this.BusLoading == true ||
			this.StudentLoading == true ||
			this.UpdatingGeoFences == true ||
			this.UpdatingBuses == true ||
			this.UpdatingStudents == true ||
			this.UpdatingTraffic == true ||
			this.UpdatingLabels == true ||
			this.UpdatingBusLabels == true ||
			this.UpdatingStudentLabels == true ||
			this.UpdatingDeselect == true
		);
	}
	//#endregion

	//#endregion
	////////////////////////////////////////////////////////////////////////////////
}
